import React, { useRef, useEffect, useState } from "react";
import { Grid, TextField, Button, Alert } from "@mui/material";

import axiosClient from "../axiosClient";
import axiosClientSevan from "../axiosClientSevan";

import { useStateContext } from "../context/ContextProvider";

const AddCompanyScreen = () => {
  const companyNameRef = useRef();
  const companyShortNameRef = useRef();
  const companyAddressRef = useRef();
  const companyZipRef = useRef();
  const companyBillingEmailRef = useRef();
  const companyVatNumberRef = useRef();
  const companyTelephoneRef = useRef();

  const { setToken } = useStateContext();

  const [customerId, setCustomerId] = useState();
  const [customerBillId, setCustomerBillId] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    axiosClient
      .get("customer/authenticated")
      .then((response) => {
        setToken(response.data.accessToken);
        setCustomerId(response.data.customer_id);
        setCustomerBillId(response.data.cust_bill_id);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleSave = () => {
    const companyPayload = {
      params: {
        companyName: companyNameRef.current.value,
        companyShortName: companyShortNameRef.current.value,
        address: companyAddressRef.current.value,
        zip: companyZipRef.current.value,
        billingEmail: companyBillingEmailRef.current.value,
        vatNumber: companyVatNumberRef.current.value,
        telephone: companyTelephoneRef.current.value,
        companyBillId: 0,
        customerId: customerId,
      },
    };

    axiosClient
      .post("customer/company/create", companyPayload)
      .then((response) => {

        const companyId = response.data.companyId
        const payloadSevan = {
          customer_code: customerBillId,
          company_name: companyNameRef.current.value,
          platform_name: "SOFTECH"
        };

        axiosClientSevan
          .post("api/create/company", payloadSevan)
          .then((response) => {
            const companyBillId = parseInt(response.data.data.company_code)

            const payload_bill = {
              params: {
                id: companyId,
                comp_bill_id: parseInt(companyBillId),
              },
            };
  
            axiosClient
              .patch("customer/company/bill", payload_bill)
              .then(()=>{
                setTimeout(() => {
                  window.location.reload();
                }, 3000);
              })
              .catch((err) => console.log(err));

            setErrorMessage("");
            setSuccessMessage(response.data.message);
          }).catch((err) => console.log(err))
      })
      .catch((err) => {
        const errorMessage = err.response.data.message.errors.map((e) => {
          return (
            <>
              {e.message}
              <br></br>
            </>
          );
        });
        setSuccessMessage("");
        setErrorMessage(errorMessage);
      });
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {successMessage && (
            <Alert severity="success" sx={{ marginBottom: 2 }}>
              {successMessage}
            </Alert>
          )}
        </Grid>
        <Grid item xs={12}>
          {errorMessage && (
            <Alert severity="error" sx={{ marginBottom: 2 }}>
              {errorMessage}
            </Alert>
          )}
        </Grid>
        <Grid item xs={12} md={3} lg={3} sm={3}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Company name"
            autoFocus
            fullWidth
            inputRef={companyNameRef}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} sm={3}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Company short name"
            fullWidth
            inputRef={companyShortNameRef}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} sm={3}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Company address"
            fullWidth
            inputRef={companyAddressRef}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} sm={3}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Company zip"
            fullWidth
            inputRef={companyZipRef}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} sm={3}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Company billing email"
            fullWidth
            inputRef={companyBillingEmailRef}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} sm={3}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Company VAT number"
            fullWidth
            inputRef={companyVatNumberRef}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} sm={3}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Company telephone"
            fullWidth
            inputRef={companyTelephoneRef}
          />
        </Grid>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 16,
            }}
          >
            <Button
              variant="contained"
              color="success"
              style={{ marginRight: 16, marginLeft: 16 }}
              onClick={handleSave}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddCompanyScreen;
